import { QuestionnaireTemplateType } from "../enum/questionnaireTemplateType";

export class QuestionnaireTemplateInfoDto {
  id: string = "";
  label: string = "";
  type: QuestionnaireTemplateType = QuestionnaireTemplateType.Standard;
  loading: boolean = false;
}